<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加划转币种配置</el-button
    >
    <el-dialog
      title="添加划转币种配置"
      width="40%"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        label-width="190px"
        :model="pairTransfer"
        :rules="rules"
        ref="currencyTransferForm"
      >
        <!-- <el-form-item label="币种名称：" prop="coinName">
          <el-input v-model="introduction.coinName"></el-input>
        </el-form-item> -->
        <el-form-item label="币种：" prop="coin">
          <el-input v-model="pairTransfer.coin" style="width: 222px"></el-input>
        </el-form-item>
        <el-form-item label="出钱包类型：" prop="fromType">
          <el-select v-model="pairTransfer.fromType" placeholder="请选择">
            <el-option
              v-for="item in datas"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入钱包类型：" prop="toType">
          <el-select v-model="pairTransfer.toType" placeholder="请选择">
            <el-option
              v-for="item in datas"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="租户选择：" prop="tenantId">
          <el-select
            v-model="pairTransfer.tenantId"
            placeholder="租户选择"
            clearable
          >
            <el-option
              v-for="item in tenantList"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="划转开关：" prop="isTransfer">
          <el-switch
            v-model="pairTransfer.isTransfer"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currencyTransferForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Editor from "components/editor";
import LANGUAGES from "common/languages";
import { validate } from "json-schema";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "CreateCurrencyIntroduction",
  data() {
    return {
      dialogVisible: false,
      pairTransfer: { isTransfer: false },
      introduction: {
        description: {},
        teamDescription: {},
      },
      options: [
        {
          value: "SPOT",
          label: "SPOT",
        },
        {
          value: "CONTRACT",
          label: "CONTRACT",
        },
      ],
      tenantList: [],
      languages: Object.keys(LANGUAGES).map((lang) => ({
        label: LANGUAGES[lang],
        value: lang,
      })),
      rules: {
        coin: [{ required: true, message: "请输入币种名称" }],
        fromType: [{ required: true, message: "请选择出钱包类型" }],
        toType: [{ required: true, message: "请选择入钱包类型" }],
        tenantId: [{ required: true, message: "请选择入租户选择" }],
      },
    };
  },
  components: {
    Editor,
  },
  computed: {
    ...mapState("currencyTransferSetting", ["datas"]),
  },
  methods: {
    ...mapActions("currencyTransferSetting", [
      "create",
      "updateOrAdd",
      "reqList",
    ]),
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateOrAdd(this.pairTransfer).then((res) => {
            if (res.code == 0) {
              this.dialogVisible = false;
              this.$emit("refresh", { page: 1, size: 25, status: "" });
              this.$message.success("添加成功");
              this.pairTransfer = {};
            }
            if (res.code == -1) {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.pairTransfer = {};
        })
        .catch((_) => {});
    },
    closeDialog() {
      this.introduction = {
        description: {},
        teamDescription: {},
      };

      this.$refs["currencyTransferForm"].resetFields();
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
  },
  created() {
    this.reqList({confKey: 'SUPPORT_TRANSFER_ACCOUNT_TYPE'}).then(res => {
      if (res.code == 0) {
        this.datas = res.data;
      }
    });
  },
};
</script>

<style lang="less" scoped></style>
